import {
  GET_CUSTOMER_RESOLUTIONS,
  GET_CUSTOMER_RESOLUTIONS_SUCCESS,
  GET_CUSTOMER_RESOLUTIONS_ERROR,
  GET_CUSTOMER_RESOLUTIONS_EMPTY,
} from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetCustomerResolutions = (state = initialState, action) => {
  switch (action.type) {
    case GET_CUSTOMER_RESOLUTIONS:
      state = {
        ...state,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_CUSTOMER_RESOLUTIONS_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_CUSTOMER_RESOLUTIONS_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_CUSTOMER_RESOLUTIONS_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetCustomerResolutions;
